import React from 'react';
import {useSelector} from 'react-redux';
import { Collapse, Button } from 'antd';
import stylesRiepilogo from '../Riepilogo.module.scss';
import Immagine from '../../../../components/Immagine/Immagine';


const { Panel } = Collapse;

const PanelIntestatario = (props) => {

    const datiSteps = useSelector(state => state.dataReducer.modello.datiPratica);
    const modalitaVerifica = datiSteps.modalitaVerifica;


    return (
        <Collapse expandIcon={({ isActive }) =>  isActive ? <Immagine urlImage={'menus.svg'} name="CLOSE" class={stylesRiepilogo.immagineCollapse} /> : <Immagine urlImage={'plus.svg'} name="OPEN" class={stylesRiepilogo.immagineCollapse} />  }>
            <Panel header={props.headerPanel} key={props.chiave}>
                    <div className={stylesRiepilogo.Riepilogo}>
                        <h3 className={stylesRiepilogo.titoloRiepilogo}>Dati Personali</h3>
                        <Button onClick={() => props.tornaAlloStep(1)} className={stylesRiepilogo.TornoIndietro}>Modifica</Button>
                        <div className={stylesRiepilogo.tabellaRiepilogo}>
                            
                            <div className={stylesRiepilogo.rigaRiepilogo}>
                                <div className={stylesRiepilogo.leftRiepilogo}>
                                    Nome
                                </div>
                                <div className={stylesRiepilogo.rightRiepilogo}>
                                    {datiSteps.nome}
                                </div>
                            </div>

                            <div className={stylesRiepilogo.rigaRiepilogo}>
                                <div className={stylesRiepilogo.leftRiepilogo}>
                                    Cognome
                                </div>
                                <div className={stylesRiepilogo.rightRiepilogo}>
                                    {datiSteps.cognome}
                                </div>
                            </div>
                            
                            <div className={stylesRiepilogo.rigaRiepilogo}>
                                <div className={stylesRiepilogo.leftRiepilogo}>
                                    Codice fiscale
                                </div>
                                <div className={stylesRiepilogo.rightRiepilogo}>
                                    {datiSteps.codiceFiscale}
                                </div>
                            </div>
                            
                            <div className={stylesRiepilogo.rigaRiepilogo}>
                                <div className={stylesRiepilogo.leftRiepilogo}>
                                    Consenso marketing (3.3)
                                </div>
                                <div className={stylesRiepilogo.rightRiepilogo}>
                                    {datiSteps.consensoMkt ? 'SI' : 'NO'}
                                </div>
                            </div>
                            
                            <div className={stylesRiepilogo.rigaRiepilogo}>
                                <div className={stylesRiepilogo.leftRiepilogo}>
                                    Consenso comunicazione a terzi (3.5)
                                </div>
                                <div className={stylesRiepilogo.rightRiepilogo}>
                                    {datiSteps.consensoTerzi ? 'SI' : 'NO'}
                                </div>
                            </div>

                            <div className={stylesRiepilogo.rigaRiepilogo}>
                                <div className={stylesRiepilogo.leftRiepilogo}>
                                    Consenso profilazione (3.4)
                                </div>
                                <div className={stylesRiepilogo.rightRiepilogo}>
                                    {datiSteps.consensoMarketing ? 'SI' : 'NO'}
                                </div>
                            </div>

                            <div className={stylesRiepilogo.rigaRiepilogo}>
                                <div className={stylesRiepilogo.leftRiepilogo}>
                                    Cessione di dati personali a Terzi - Prevalutazione Prodotti di Terzi (3.6)
                                </div>
                                <div className={stylesRiepilogo.rightRiepilogo}>
                                    {datiSteps.consentFourth ? 'SI' : 'NO'}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className={stylesRiepilogo.Riepilogo}>
                        <h3 className={stylesRiepilogo.titoloRiepilogo}>Contatti</h3>
                        <Button onClick={() => props.tornaAlloStep(2)} className={stylesRiepilogo.TornoIndietro}>Modifica</Button>
                        <div className={stylesRiepilogo.tabellaRiepilogo}>

                            <div className={stylesRiepilogo.rigaRiepilogo}>
                                <div className={stylesRiepilogo.leftRiepilogo}>
                                    Email
                                </div>
                                <div className={stylesRiepilogo.rightRiepilogo}>
                                    {datiSteps.email}
                                </div>
                            </div>

                            <div className={stylesRiepilogo.rigaRiepilogo}>
                                <div className={stylesRiepilogo.leftRiepilogo}>
                                    Cellulare
                                </div>
                                <div className={stylesRiepilogo.rightRiepilogo}>
                                    {datiSteps.cellulare}
                                </div>
                            </div>

                            {datiSteps.telefono !== null && datiSteps.telefono !== "" ? (

                                <div className={stylesRiepilogo.rigaRiepilogo}>
                                    <div className={stylesRiepilogo.leftRiepilogo}>
                                        Telefono
                                    </div>
                                    <div className={stylesRiepilogo.rightRiepilogo}>
                                        {datiSteps.telefono}
                                    </div>
                                </div>

                            ) : null }

                        </div>
                    </div>


                    <div className={stylesRiepilogo.Riepilogo}>
                        <h3 className={stylesRiepilogo.titoloRiepilogo}>IBAN</h3>
                        { modalitaVerifica ? <Button  onClick={() => props.tornaAlloStep(3)} className={stylesRiepilogo.TornoIndietro}>Modifica</Button> : null }
                        <div className={stylesRiepilogo.tabellaRiepilogo}>

                            <div className={stylesRiepilogo.rigaRiepilogo}>
                                <div className={stylesRiepilogo.leftRiepilogo}>
                                    IBAN
                                </div>
                                <div className={`${stylesRiepilogo.rightRiepilogo} ${stylesRiepilogo.rightRiepilogoMaxSize} `}>
                                    {datiSteps.iban}
                                </div>
                            </div>

                        </div>
                    </div>


                    <div className={stylesRiepilogo.Riepilogo}>
                        <h3 className={stylesRiepilogo.titoloRiepilogo}>Persona esposta</h3>
                        <Button onClick={() => props.tornaAlloStep(4)} className={stylesRiepilogo.TornoIndietro}>Modifica</Button>
                        <div className={stylesRiepilogo.tabellaRiepilogo}>

                            <div className={stylesRiepilogo.rigaRiepilogo}>
                                <div className={stylesRiepilogo.leftRiepilogo}>
                                    Sei una persona politicamente esposta ?
                                </div>
                                <div className={stylesRiepilogo.rightRiepilogo}>
                                    {datiSteps.personaEsposta ? 'SI' : 'NO'}
                                </div>
                            </div>

                        </div>
                    </div>
            </Panel>
        </Collapse>
    )
}

export default PanelIntestatario;